import { SxProps, Theme } from "@mui/material/styles";
import { DropzoneContainerProps } from "./types";

/**
 * Generate styles for the dropzone container based on its state
 */
export const getDropzoneContainerStyles = (
  props: DropzoneContainerProps
): SxProps<Theme> => {
  const { isError, isDragActive } = props;

  return {
    padding: 3,
    borderRadius: 1,
    border: (theme: Theme) =>
      `2px dashed ${isError ? theme.palette.error.main : theme.palette.grey[400]}`,
    backgroundColor: (theme: Theme) =>
      isDragActive ? theme.palette.action.hover : "transparent",
    cursor: "pointer",
    transition: "border-color 0.2s, background-color 0.2s",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    "&:hover": {
      borderColor: (theme: Theme) =>
        isDragActive
          ? theme.palette.primary.main
          : isError
            ? theme.palette.error.main
            : theme.palette.grey[600],
    },
    minHeight: 150,
  };
};

/**
 * Styles for the upload icon (as React CSSProperties)
 */
export const uploadIconStyles = {
  fontSize: 60,
  color: "grey",
  marginBottom: 16,
};
